import s from './store'

var store = undefined;

export default {
    init(){
        store = s;
    },
    getStore(){
        return store;
    }
};



// WEBPACK FOOTER //
// ./src/js/storeProvider.js